var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChevronDown = function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13.2 16.698 6.007-5.997a.998.998 0 0 0-1.412-1.41L12.5 14.58 7.202 9.292a.998.998 0 0 0-1.702.71c0 .26.1.51.29.71l6.008 5.996a.998.998 0 0 0 1.412 0l-.01-.01Z"
  })));
};
export default SvgChevronDown;